import React from 'react';
import { AuthContextModel } from '../../Context';
import { AmountControl, LabelField } from '../Controls';
import './manager-discount.css';

const ManagerDiscountRow = ({
  id,
  onChange,
  label,
  value,
  discountTotal,
  isQuoteDiscountTypeManager,
  lockedState,
  disabledState,
}) => {
  const discountTotalValue = isQuoteDiscountTypeManager ? discountTotal : '-';

  return (
    <div className="row-manager-discount">
      {AuthContextModel.hasInternalPermissions ? (
        <AmountControl
          onChange={onChange}
          id={id}
          max={100}
          decimals={2}
          marker="%"
          lockedState={lockedState}
          disabledState={disabledState}
          label={label}
          value={value}
        />
      ) : (
        <LabelField label={label} value={value + '%'} />
      )}
      <LabelField parentClassName="discount-total-wrapper" className="discount-total" value={discountTotalValue} />
    </div>
  );
};

export default ManagerDiscountRow;
